/*
 * @Description:
 * @Date: 2020-07-19 13:03:36
 */
import { BI } from '@/api/ajax';

class BIServiceBase {
  constructor(query) {
    this.query = query;
    this.ajax = BI;
  }
  async run(that) {
    let arr = [];
    for (let i of that) {
      if (i !== 'run' && typeof that[i] === 'function') {
        arr.push(that[i]());
      }
    }
    return new Promise(resolve => {
      Promise.all(arr).then(res => {
        resolve(res);
      });
    });
  }
}
export default BIServiceBase;
